import Component from 'react-pure-render/component';
import Helmet from 'react-helmet';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    defaultMessage: 'Profile',
    id: 'me.profilePage.title'
  }
});

export default class ProfilePage extends Component {

  render() {
    return (
      <div className="profile-page">
        <FormattedMessage {...messages.title}>
          {message => <Helmet title={message} />}
        </FormattedMessage>
        <p>
          <FormattedMessage {...messages.title} />
        </p>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/browser/me/ProfilePage.react.js